import React, { FC } from 'react';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import translate from '@translate';
import Dialog from 'src/components/Dialog';
import Grid, { GridItem } from 'src/components/Grid';
import OptionsSimpleTable from 'src/components/OptionsSimpleTable';
import Typography from '../../components/Typography';

export interface ColumnOptionsProps {
    claimStatusCodes: ConstantsCodeType[];
    currencyCodes: ConstantsCodeType[];
    onClose: () => void;
}

const ColumnOptions: FC<ColumnOptionsProps> = (props) => {
    return (
        <Dialog
            maxWidth="md"
            title={translate('claimsImport.columnsOptions')}
            onClose={props.onClose}
            sx={{
                paddingBottom: 0,
                '& .MuiDialogTitle-root': { paddingBottom: 0 },
                '& .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2': { marginTop: 0 },
            }}
        >
            <Grid>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>FCN:</strong> {translate('claimDetail.fcn')} ({translate('claimsImport.requiredColumn')})
                    </Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="STATUS" options={props.claimStatusCodes} />
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>TRANSPORT_PRICE:</strong> {translate('claimDetail.transportPrice')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>GOODS_PRICE:</strong> {translate('claimDetail.goodsPrice')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>TOTAL_SERVICE_PRICE:</strong> {translate('claimDetail.totalServicePrice')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="COMPENSATION_CURRENCY" options={props.currencyCodes} onlyValue />
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>CARRIER_INVOICE_REFERENCE:</strong> {translate('claimDetail.carrierInvoiceReference')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>ISSUES_MONTH_ORIGIN:</strong> {translate('claimDetail.issuesMonthOrigin')} ({translate('format')} YYYY/MM/DD)
                    </Typography>
                </GridItem>
            </Grid>
        </Dialog>
    );
};

export default ColumnOptions;
